<p class="text-xl sm:text-xl font-bold mb-4">
  {{ 'LEAD_DASHBOARD.TITLE' | translate }}
</p>

<section class="bg-white rounded-xl shadow-sm p-3 mb-2">
  <h2 class="text-xl font-semibold mb-2">
    {{ 'LEAD_DASHBOARD.TOTAL_LEADS' | translate }}
    <span class="text-xl font-bold ms-2 color-primary">{{ totalLeads }}</span>
  </h2>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5">
    <div class="relative rounded-xl p-3 bg-[#DCFCE7] min-h-[120px] min-w-[140px]">
      <div
        class="absolute top-3 end-4 w-8 h-8 rounded-full bg-[#3CD856] flex items-center justify-center"
      >
        <img src="images/sale-icon.png" alt="" class="h-5 w-5 object-contain" />
      </div>
      <div class="text-4xl font-bold text-slate-900 text-start">{{ newToday }}</div>
      <div class="mt-3 text-sm font-medium text-slate-700 leading-snug">
        {{ 'LEAD_DASHBOARD.NEW_LEADS_TODAY' | translate }}
      </div>
    </div>

    <div class="relative rounded-xl p-3 bg-[#FFE2E5] min-h-[120px] min-w-[140px]">
      <div
        class="absolute top-3 end-4 w-8 h-8 rounded-full bg-[#FA5A7D] flex items-center justify-center"
      >
        <img src="images/term-sheet.png" alt="" class="h-5 w-5 object-contain" />
      </div>
      <div class="text-4xl font-bold text-slate-900 text-start">{{ awaitingTermSheet }}</div>
      <div class="mt-3 text-sm font-medium text-slate-700 leading-snug">
        {{ 'LEAD_DASHBOARD.LEADS_AWAITING_TERM_SHEET' | translate }}
      </div>
    </div>

    <div class="relative rounded-xl p-3 bg-[#E4E4FF] min-h-[120px] min-w-[140px]">
      <div
        class="absolute top-3 end-4 w-8 h-8 rounded-full bg-[#8585FD] flex items-center justify-center"
      >
        <img src="images/approval.svg" alt="" class="h-5 w-5 object-contain" />
      </div>
      <div class="text-4xl font-bold text-slate-900 text-start">{{ awaitingApproval }}</div>
      <div class="mt-3 text-sm font-medium text-slate-700 leading-snug">
        {{ 'LEAD_DASHBOARD.LEADS_AWAITING_APPROVAL' | translate }}
      </div>
    </div>

    <div class="relative rounded-xl p-3 bg-[#FFF4DE] min-h-[120px] min-w-[140px]">
      <div
        class="absolute top-3 end-4 w-8 h-8 rounded-full bg-[#FF947A] flex items-center justify-center"
      >
        <img src="images/proposal.png" alt="" class="h-5 w-5 object-contain" />
      </div>
      <div class="text-4xl font-bold text-slate-900 text-start">{{ clientDecision }}</div>
      <div class="mt-3 text-sm font-medium text-slate-700 leading-snug">
        {{ 'LEAD_DASHBOARD.PROPOSALS_AWAITING_CLIENT_DECISION' | translate }}
      </div>
    </div>

    <div class="relative rounded-xl p-3 bg-[#F3E8FF] min-h-[120px] min-w-[140px]">
      <div
        class="absolute top-3 end-4 w-8 h-8 rounded-full bg-[#9A62D8] flex items-center justify-center"
      >
        <img src="images/open-leads.png" alt="" class="h-5 w-5 object-contain" />
      </div>
      <div class="text-4xl font-bold text-slate-900 text-start">{{ openLeads }}</div>
      <div class="mt-3 text-sm font-medium text-slate-700 leading-snug">
        {{ 'LEAD_DASHBOARD.MY_OPEN_LEADS' | translate }}
      </div>
    </div>

    <div class="relative rounded-xl p-3 bg-cyan-100 min-h-[120px] min-w-[140px]">
      <div
        class="absolute top-3 end-4 w-8 h-8 rounded-full bg-cyan-500 flex items-center justify-center"
      >
        <img src="images/pending.png" alt="" class="h-5 w-5 object-contain" />
      </div>
      <div class="text-4xl font-bold text-slate-900 text-start">{{ pendingApprovals }}</div>
      <div class="mt-3 text-sm font-medium text-slate-700 leading-snug">
        {{ 'LEAD_DASHBOARD.PENDING_APPROVALS' | translate }}
      </div>
    </div>
  </div>
</section>

<div class="title flex items-center justify-between">
  <h2 class="text-xl font-bold mb-4">
    {{ 'LEAD_DASHBOARD.LEADS_LIST' | translate }}
  </h2>

  <button
    *ngIf="permissionService.hasAccess('/add-new-leads')"
    (click)="addNewLead()"
    class="ms-2 bg-secondary text-white px-4 py-2 rounded-lg"
  >
    {{ 'LEAD_DASHBOARD.ADD_NEW_LEAD' | translate }}
  </button>
</div>

<div class="flex flex-wrap gap-2">
  <button
    (click)="setTab('all')"
    [ngClass]="activeTab === 'all' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'"
    class="px-4 py-2 rounded-lg"
  >
    {{ 'LEAD_DASHBOARD.ALL_LEADS' | translate }}
  </button>

  <button
  *ngIf="isRelationshipOfficer"
  (click)="setTab('clientApproval')"
  [ngClass]="
    activeTab === 'clientApproval' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
  "
  class="px-4 py-2 rounded-lg flex items-center gap-2"
>
  {{ 'LEAD_DASHBOARD.CLIENT_APPROVAL' | translate }}

  <span
    class="min-w-5 h-5 px-1 rounded-full text-xs flex items-center justify-center"
    [ngClass]="
      activeTab === 'clientApproval' ? 'bg-white text-[#605BFF]' : 'bg-secondary text-white'
    "
  >
    {{ clientApprovalLeads.length }}
  </span>
</button>

  <button
    *ngIf="canViewPendingApprovals"
    (click)="setTab('pendingApproval')"
    [ngClass]="
      activeTab === 'pendingApproval' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
    "
    class="px-4 py-2 rounded-lg flex items-center gap-2"
  >
    {{ 'LEAD_DASHBOARD.PENDING_APPROVALS' | translate }}

    <span
      class="min-w-5 h-5 px-1 rounded-full text-xs flex items-center justify-center"
      [ngClass]="
        activeTab === 'pendingApproval' ? 'bg-white text-[#605BFF]' : 'bg-secondary text-white'
      "
    >
      {{ pendingApprovalLeads.length }}
    </span>
  </button>
</div>

<div class="mt-4 overflow-x-auto">
  <!-- All Leads Empty -->
  <div
    *ngIf="activeTab === 'all' && leads.length === 0"
    class="flex flex-col items-center py-16 text-gray-400 bg-white rounded-lg"
  >
    <img src="images/no-data-image.jpg" class="w-44 mb-4 opacity-70" />
    <p class="text-lg font-medium">{{ 'LEAD_DASHBOARD.NO_LEADS_FOUND' | translate }}</p>
  </div>

  <!-- Client Approval Empty -->
  <div
    *ngIf="activeTab === 'clientApproval' && clientApprovalLeads.length === 0"
    class="flex flex-col items-center py-16 text-gray-400 bg-white rounded-lg"
  >
    <img src="images/no-data-image.jpg" class="w-44 mb-4 opacity-70" />
    <p class="text-lg font-medium">{{ 'LEAD_DASHBOARD.NO_CLIENT_APPROVAL_LEADS_FOUND' | translate }}</p>
  </div>

  <!-- Pending Approval Empty -->
  <div
    *ngIf="
      canViewPendingApprovals &&
      activeTab === 'pendingApproval' &&
      pendingApprovalLeads.length === 0
    "
    class="flex flex-col items-center py-16 text-gray-400 bg-white rounded-lg"
  >
    <img src="images/no-data-image.jpg" class="w-44 mb-4 opacity-70" />
    <p class="text-lg font-medium">{{ 'LEAD_DASHBOARD.NO_PENDING_APPROVAL_LEADS_FOUND' | translate }}</p>
  </div>

  <!-- All Leads Table -->
  <app-table
    *ngIf="activeTab === 'all' && leads.length > 0"
    [columns]="columns"
    [data]="leads"
    [actions]="actions"
    [selectable]="false"
    [enablePagination]="true"
    [pageSize]="10"
  >
  </app-table>

  <!-- Client Approval Table -->
  <app-table
    *ngIf="activeTab === 'clientApproval' && clientApprovalLeads.length > 0"
    [columns]="columns"
    [data]="clientApprovalLeads"
    [actions]="clientApprovalActions"
    [selectable]="false"
    [enablePagination]="true"
    [pageSize]="12"
  >
  </app-table>

  <!-- Pending Approval Table -->
  <app-table
    *ngIf="
      canViewPendingApprovals && activeTab === 'pendingApproval' && pendingApprovalLeads.length > 0
    "
    [columns]="columns"
    [data]="pendingApprovalLeads"
    [actions]="pendingApprovalActions"
    [selectable]="false"
    [enablePagination]="true"
    [pageSize]="10"
  >
  </app-table>
</div>

<app-popup
  [(show)]="showReviewPopup"
  title="LEAD_DASHBOARD.SEND_LEAD_FOR_REVIEW"
  type="custom"
  width="w-full max-w-4xl"
>
  <div class="space-y-6">
    <!-- COMMENT BOX -->
    <div class="border rounded-2xl p-5 bg-gray-50">
      <div class="flex items-center justify-between mb-3">
        <h3 class="font-semibold text-lg text-[#0B0D5C]">
          {{ 'LEAD_DASHBOARD.ADD_A_COMMENT' | translate }}
          <span class="text-red-500">*</span>
        </h3>

        <span class="text-sm text-gray-400"> {{ reviewComment.length }}/5000 </span>
      </div>

      <textarea
        [(ngModel)]="reviewComment"
        rows="6"
        maxlength="5000"
        class="w-full border border-gray-200 rounded-xl p-4 bg-white outline-none resize-none"
        [placeholder]="'LEAD_DASHBOARD.SHARE_FEEDBACK_PLACEHOLDER' | translate"
      ></textarea>

      <p class="text-sm text-gray-400 mt-3">{{ 'LEAD_DASHBOARD.COMMENT_VISIBLE_TO_REVIEWERS' | translate }}</p>
    </div>

    <!-- REVIEW HISTORY -->
    <div>
      <div class="flex items-center gap-2 mb-4">
        <h3 class="font-semibold text-lg text-[#0B0D5C]">{{ 'LEAD_DASHBOARD.REVIEW_HISTORY' | translate }}</h3>

        <span class="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded-full">
          {{ reviewHistory.length }}
        </span>
      </div>

      <!-- EMPTY -->
      <div
        *ngIf="!reviewHistory.length"
        class="border-2 border-dashed rounded-2xl p-12 text-center text-gray-400"
      >
        <div class="text-lg font-medium mb-1">{{ 'LEAD_DASHBOARD.NO_COMMENTS_YET' | translate }}</div>

        <p>{{ 'LEAD_DASHBOARD.BE_FIRST_REVIEW_COMMENT' | translate }}</p>
      </div>

      <!-- HISTORY -->
      <div *ngIf="reviewHistory.length" class="max-h-[300px] overflow-y-auto space-y-4 pe-2">
        <div *ngFor="let item of reviewHistory" class="border rounded-2xl p-4 bg-gray-50 min-w-0">
          <div class="flex items-center justify-between mb-2">
            <div class="font-semibold text-[#0B0D5C]">
              {{ item.crtdBy || ('LEAD_DASHBOARD.USER' | translate) }}
            </div>

            <div class="text-xs text-gray-400">
              <span dir="ltr">{{ item.crtdDt | date: 'medium' }}</span>
            </div>
          </div>

          <p class="text-sm text-gray-700 whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
            {{ item.cmmnt }}
          </p>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="flex justify-end gap-3 pt-2">
      <button class="btn-primary" (click)="submitReviewComment()">{{ 'COMMON.SUBMIT' | translate }}</button>

      <button class="btn-danger" (click)="showReviewPopup = false">{{ 'COMMON.CANCEL' | translate }}</button>
    </div>
  </div>
</app-popup>

<app-popup [(show)]="showLeadActionPopup" title="LEAD_DASHBOARD.LEAD_ACTION" type="custom" width="w-full max-w-md">
  <div class="space-y-5">
    <p class="text-sm text-gray-600">{{ 'LEAD_DASHBOARD.SELECT_LEAD_ACTION' | translate }}</p>

    <label
      class="flex items-start gap-3 p-4 border rounded-xl cursor-pointer"
      [ngClass]="
        selectedLeadAction === 'sendBackToRO' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
      "
    >
      <input
        type="radio"
        name="leadAction"
        value="sendBackToRO"
        [(ngModel)]="selectedLeadAction"
        class="mt-1"
      />

      <div>
        <p class="font-semibold text-gray-800">{{ 'LEAD_DASHBOARD.SEND_BACK_TO_RO' | translate }}</p>
        <p class="mt-1 text-sm text-gray-500">
          {{ 'LEAD_DASHBOARD.SEND_BACK_TO_RO_DESC' | translate }}
        </p>
      </div>
    </label>

    <label
      class="flex items-start gap-3 p-4 border rounded-xl cursor-pointer"
      [ngClass]="selectedLeadAction === 'reject' ? 'border-red-500 bg-red-50' : 'border-gray-200'"
    >
      <input
        type="radio"
        name="leadAction"
        value="reject"
        [(ngModel)]="selectedLeadAction"
        class="mt-1"
      />

      <div>
        <p class="font-semibold text-red-700">{{ 'LEAD_DASHBOARD.PERMANENT_REJECT' | translate }}</p>
        <p class="mt-1 text-sm text-gray-500">{{ 'LEAD_DASHBOARD.PERMANENT_REJECT_DESC' | translate }}</p>
      </div>
    </label>

    <div class="flex justify-end gap-3 pt-3">
      <button
        class="btn-primary"
        [disabled]="isLeadActionSubmitting"
        (click)="prepareLeadActionConfirmation()"
      >
        {{ 'COMMON.CONTINUE' | translate }}
      </button>

      <button
        class="btn-danger"
        [disabled]="isLeadActionSubmitting"
        (click)="closeLeadActionPopup()"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  </div>
</app-popup>

<app-popup
  [title]="leadConfirmTitle"
  type="custom"
  width="w-full max-w-4xl"
  [show]="showLeadConfirmPopup"
  (showChange)="showLeadConfirmPopup = $event"
>
  <div class="space-y-6">
    <p class="text-sm text-gray-600">
      {{ leadConfirmMessage }}
    </p>

    <div
      *ngIf="leadActionSource === 'pendingApproval' && selectedLeadAction !== 'delete'"
      class="border rounded-2xl p-5 bg-gray-50"
    >
      <div class="flex items-center justify-between mb-3">
        <h3 class="font-semibold text-lg text-[#0B0D5C]">
          {{ 'LEAD_DASHBOARD.COMMENT' | translate }}
          <span class="text-red-500 text-sm font-normal"> *</span>
        </h3>

        <span class="text-sm text-gray-400">
          {{ leadActionComment.length }}/5000
        </span>
      </div>

      <textarea
        [(ngModel)]="leadActionComment"
        rows="6"
        maxlength="5000"
        class="w-full border border-gray-200 rounded-xl p-4 bg-white outline-none resize-none"
        [placeholder]="'LEAD_DASHBOARD.WRITE_COMMENT_PLACEHOLDER' | translate"
      ></textarea>

      <p class="text-sm text-gray-400 mt-3">
        {{ 'LEAD_DASHBOARD.COMMENT_SAVED_BEFORE_PROCESSING' | translate }}
      </p>
    </div>

    <div *ngIf="leadActionSource === 'pendingApproval' && selectedLeadAction !== 'delete'">
      <div class="flex items-center gap-2 mb-4">
        <h3 class="font-semibold text-lg text-[#0B0D5C]">{{ 'LEAD_DASHBOARD.REVIEW_HISTORY' | translate }}</h3>

        <span class="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded-full">
          {{ leadActionHistory.length }}
        </span>
      </div>

      <div
        *ngIf="!leadActionHistory.length"
        class="border-2 border-dashed rounded-2xl p-12 text-center text-gray-400"
      >
        <div class="text-lg font-medium mb-1">{{ 'LEAD_DASHBOARD.NO_COMMENTS_YET' | translate }}</div>
        <p>{{ 'LEAD_DASHBOARD.BE_FIRST_COMMENT' | translate }}</p>
      </div>

      <div
        *ngIf="leadActionHistory.length"
        class="max-h-[300px] overflow-y-auto space-y-4 pe-2"
      >
        <div *ngFor="let item of leadActionHistory" class="border rounded-2xl p-4 bg-gray-50">
          <div class="flex items-center justify-between mb-2">
            <div class="font-semibold text-[#0B0D5C]">
              {{ item.crtdBy || ('LEAD_DASHBOARD.USER' | translate) }}
            </div>

            <div class="text-xs text-gray-400">
              <span dir="ltr">{{ item.crtdDt | date: 'medium' }}</span>
            </div>
          </div>

          <p class="text-sm text-gray-700 whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
            {{ item.cmmnt }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-3 pt-2">
      <button
        class="btn-primary"
        [disabled]="isLeadActionSubmitting"
        (click)="confirmLeadAction()"
      >
        {{ leadConfirmText | translate }}
      </button>

      <button
        class="btn-danger"
        [disabled]="isLeadActionSubmitting"
        (click)="showLeadConfirmPopup = false"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  </div>
</app-popup>

<app-popup
  [(show)]="showRejectCommentPopup"
  title="LEAD_DASHBOARD.REJECT_LEAD"
  type="custom"
  width="w-full max-w-4xl"
>
  <div class="space-y-6">
    <div class="border rounded-2xl p-5 bg-gray-50">
      <div class="flex items-center justify-between mb-3">
        <h3 class="font-semibold text-lg text-[#0B0D5C]">
          {{ 'LEAD_DASHBOARD.REJECT_COMMENT' | translate }}
          <span class="text-red-500 text-sm font-normal"> *</span>
        </h3>

        <span class="text-sm text-gray-400">
          {{ rejectComment.length }}/5000
        </span>
      </div>

      <textarea
        [(ngModel)]="rejectComment"
        rows="6"
        maxlength="5000"
        class="w-full border border-gray-200 rounded-xl p-4 bg-white outline-none resize-none"
        [placeholder]="'LEAD_DASHBOARD.WRITE_REJECTION_REASON_PLACEHOLDER' | translate"
      ></textarea>

      <p class="text-sm text-gray-400 mt-3">
        {{ 'LEAD_DASHBOARD.COMMENT_SAVED_BEFORE_REJECTING' | translate }}
      </p>
    </div>

    <div>
      <div class="flex items-center gap-2 mb-4">
        <h3 class="font-semibold text-lg text-[#0B0D5C]">{{ 'LEAD_DASHBOARD.REVIEW_HISTORY' | translate }}</h3>

        <span class="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded-full">
          {{ rejectHistory.length }}
        </span>
      </div>

      <div
        *ngIf="!rejectHistory.length"
        class="border-2 border-dashed rounded-2xl p-12 text-center text-gray-400"
      >
        <div class="text-lg font-medium mb-1">{{ 'LEAD_DASHBOARD.NO_COMMENTS_YET' | translate }}</div>
        <p>{{ 'LEAD_DASHBOARD.BE_FIRST_REJECT_COMMENT' | translate }}</p>
      </div>

      <div *ngIf="rejectHistory.length" class="max-h-[300px] overflow-y-auto space-y-4 pe-2">
        <div *ngFor="let item of rejectHistory" class="border rounded-2xl p-4 bg-gray-50">
          <div class="flex items-center justify-between mb-2">
            <div class="font-semibold text-[#0B0D5C]">
              {{ item.crtdBy || ('LEAD_DASHBOARD.USER' | translate) }}
            </div>

            <div class="text-xs text-gray-400">
              <span dir="ltr">{{ item.crtdDt | date: 'medium' }}</span>
            </div>
          </div>

          <p class="text-sm text-gray-700 whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
            {{ item.cmmnt }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-3 pt-2">
      <button
        class="btn-danger"
        [disabled]="isRejectSubmitting"
        (click)="submitRejectComment()"
      >
        {{ 'COMMON.REJECT' | translate }}
      </button>

      <button
        class="btn-primary"
        [disabled]="isRejectSubmitting"
        (click)="closeRejectCommentPopup()"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  </div>
</app-popup>
<app-popup [(show)]="showConfirmPopup" title="COMMON.CONFIRM" type="custom" width="w-full max-w-md">
  <p class="text-sm text-gray-600">{{ confirmMessage }}</p>
  <div class="flex justify-end gap-3 pt-4">
    <button class="btn-primary" (click)="onPopupConfirmed()">{{ 'LEAD_DASHBOARD.YES_APPROVE' | translate }}</button>
    <button class="btn-danger" (click)="showConfirmPopup = false; pendingLead = null; popupAction = null">{{ 'COMMON.CANCEL' | translate }}</button>
  </div>
</app-popup>